import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './separator.less'

class Separator extends React.Component {
  static propTypes = {
    text: PropTypes.string,
    type: PropTypes.oneOf(['solid', 'dotted']),
  }

  static defaultProps = { type: 'solid' }

  render() {
    if (this.props.text) {
      return (
        <div styleName="separator-container">
          <div styleName={`separator-${this.props.type}`} />
          {this.props.text && (
            <div styleName="separator-text">{this.props.text}</div>
          )}
        </div>
      )
    }
    return <div styleName={`separator-${this.props.type}`} />
  }
}

export default cssModules(Separator, styles, { allowMultiple: true })
